/*
This file is generated.
Do not modify manually, instead refer to build-sounds.js
*/
// tslint:disable
/* es-lint:disable */
var _a;
import { IdSoundGroup } from "../../utils/sound/IdSoundGroup";
import { IdSound } from "./IdSound";
export var soundSpriteConfig = (_a = {},
    _a[IdSound.MU_Main_01] = {
        id: IdSound.MU_Main_01,
        range: [0, 68727.27891156463],
        group: IdSoundGroup.Music,
    },
    _a[IdSound.Dog_Bark] = {
        id: IdSound.Dog_Bark,
        range: [0, 332.53968253968253],
        group: IdSoundGroup.Sound,
    },
    _a[IdSound.UI_SpendGold] = {
        id: IdSound.UI_SpendGold,
        range: [432.53968253968253, 1101.4512471655328],
        group: IdSoundGroup.Sound,
    },
    _a[IdSound.Dog_Celebration_NoCollar] = {
        id: IdSound.Dog_Celebration_NoCollar,
        range: [1633.9909297052154, 1758.7074829931971],
        group: IdSoundGroup.Sound,
    },
    _a[IdSound.Dog_Howl] = {
        id: IdSound.Dog_Howl,
        range: [3492.6984126984125, 332.5396825396827],
        group: IdSoundGroup.Sound,
    },
    _a[IdSound.Dog_IdleLong] = {
        id: IdSound.Dog_IdleLong,
        range: [3925.2380952380954, 2148.0045351473927],
        group: IdSoundGroup.Sound,
    },
    _a[IdSound.Dog_IdlePlayful] = {
        id: IdSound.Dog_IdlePlayful,
        range: [6173.242630385488, 3442.018140589569],
        group: IdSoundGroup.Sound,
    },
    _a[IdSound.Dog_IdlePlayful_NoCollar] = {
        id: IdSound.Dog_IdlePlayful_NoCollar,
        range: [9715.260770975057, 3442.018140589569],
        group: IdSoundGroup.Sound,
    },
    _a[IdSound.Dog_Sniff] = {
        id: IdSound.Dog_Sniff,
        range: [13257.278911564626, 3452.018140589569],
        group: IdSoundGroup.Sound,
    },
    _a[IdSound.Dog_Sniff_NoCollar] = {
        id: IdSound.Dog_Sniff_NoCollar,
        range: [16809.297052154197, 3452.018140589569],
        group: IdSoundGroup.Sound,
    },
    _a[IdSound.Dog_Whine] = {
        id: IdSound.Dog_Whine,
        range: [20361.31519274377, 332.53968253968225],
        group: IdSoundGroup.Sound,
    },
    _a[IdSound.SFX_Truck_Loop] = {
        id: IdSound.SFX_Truck_Loop,
        range: [20793.85487528345, 4992.018140589568],
        group: IdSoundGroup.Sound,
    },
    _a[IdSound.SFX_Truck_Start] = {
        id: IdSound.SFX_Truck_Start,
        range: [25885.87301587302, 1130.6802721088438],
        group: IdSoundGroup.Sound,
    },
    _a[IdSound.SFX_Truck_Stop] = {
        id: IdSound.SFX_Truck_Stop,
        range: [27116.553287981864, 2045.3514739229029],
        group: IdSoundGroup.Sound,
    },
    _a[IdSound.UI_BuildingCelebration] = {
        id: IdSound.UI_BuildingCelebration,
        range: [29261.90476190477, 3259.3424036281144],
        group: IdSoundGroup.Sound,
    },
    _a[IdSound.UI_BuildingFinish] = {
        id: IdSound.UI_BuildingFinish,
        range: [32621.247165532885, 1500],
        group: IdSoundGroup.Sound,
    },
    _a[IdSound.UI_BuildingPick] = {
        id: IdSound.UI_BuildingPick,
        range: [34221.247165532885, 468.1405895691597],
        group: IdSoundGroup.Sound,
    },
    _a[IdSound.Dog_Celebration] = {
        id: IdSound.Dog_Celebration,
        range: [34789.38775510205, 1758.6848072562375],
        group: IdSoundGroup.Sound,
    },
    _a[IdSound.UI_BuildingRotate] = {
        id: IdSound.UI_BuildingRotate,
        range: [36648.072562358284, 265.8276643990902],
        group: IdSoundGroup.Sound,
    },
    _a[IdSound.UI_Collectwater] = {
        id: IdSound.UI_Collectwater,
        range: [37013.90022675738, 762.6757369614481],
        group: IdSoundGroup.Sound,
    },
    _a[IdSound.UI_ContractTrash] = {
        id: IdSound.UI_ContractTrash,
        range: [37876.57596371883, 452.04081632653015],
        group: IdSoundGroup.Sound,
    },
    _a[IdSound.UI_Generic] = {
        id: IdSound.UI_Generic,
        range: [38428.61678004536, 47.07482993197232],
        group: IdSoundGroup.Sound,
    },
    _a[IdSound.UI_HarvestReady] = {
        id: IdSound.UI_HarvestReady,
        range: [38575.69160997734, 830.544217687077],
        group: IdSoundGroup.Sound,
    },
    _a[IdSound.UI_ItemCollect] = {
        id: IdSound.UI_ItemCollect,
        range: [39506.235827664415, 144.26303854875044],
        group: IdSoundGroup.Sound,
    },
    _a[IdSound.UI_ItemSold] = {
        id: IdSound.UI_ItemSold,
        range: [39750.498866213165, 876.3945578231258],
        group: IdSoundGroup.Sound,
    },
    _a[IdSound.UI_ItemSpawn] = {
        id: IdSound.UI_ItemSpawn,
        range: [40726.893424036294, 128.84353741496568],
        group: IdSoundGroup.Sound,
    },
    _a[IdSound.UI_LevelUp] = {
        id: IdSound.UI_LevelUp,
        range: [40955.73696145126, 4000],
        group: IdSoundGroup.Sound,
    },
    _a[IdSound.UI_ProduceFeed] = {
        id: IdSound.UI_ProduceFeed,
        range: [45055.73696145126, 994.1723356009078],
        group: IdSoundGroup.Sound,
    },
    _a[IdSound.UI_ProduceFertilise] = {
        id: IdSound.UI_ProduceFertilise,
        range: [46149.90929705217, 1000],
        group: IdSoundGroup.Sound,
    },
    _a[IdSound.UI_ProduceProduct] = {
        id: IdSound.UI_ProduceProduct,
        range: [47249.90929705217, 47.07482993197232],
        group: IdSoundGroup.Sound,
    },
    _a[IdSound.UI_ProduceSow] = {
        id: IdSound.UI_ProduceSow,
        range: [47396.98412698414, 300.9523809523813],
        group: IdSoundGroup.Sound,
    },
    _a[IdSound.UI_QuestComplete] = {
        id: IdSound.UI_QuestComplete,
        range: [47797.93650793652, 1000],
        group: IdSoundGroup.Sound,
    },
    _a[IdSound.UI_Scroll] = {
        id: IdSound.UI_Scroll,
        range: [48897.93650793653, 58.616780045348094],
        group: IdSoundGroup.Sound,
    },
    _a[IdSound.UI_BuildingPlace] = {
        id: IdSound.UI_BuildingPlace,
        range: [49056.55328798188, 500],
        group: IdSoundGroup.Sound,
    },
    _a);



//////////////////
// WEBPACK FOOTER
// ./src/setup/sound/soundSpriteConfig.ts
// module id = 907
// module chunks = 3